import type {
  FantasyLeaderboardEntry,
  FantasyLeaderboardSection
} from '~/types/fantasy'

export const normalizeLeaderboardEntry = (
  entry: Omit<FantasyLeaderboardEntry, 'id'>
): FantasyLeaderboardEntry => ({
  ...entry,
  id: entry.member.id
})

export const normalizeLeaderboardSections = (
  sections: {
    top_percent: number
    items: Omit<FantasyLeaderboardEntry, 'id'>[]
  }[]
): FantasyLeaderboardSection[] =>
  sections.map(section => ({
    top_percent: section.top_percent,
    items: section.items.map(normalizeLeaderboardEntry)
  }))
